import React from 'react';
import './App.css'
function InvalidPath(){
    return (
      <div className="Row">
      <p><b>The ResourceR you Looking For Is Not found </b></p>  
      </div>    
    )
}
export default InvalidPath